class CarouselTabbed extends HTMLElement {
  constructor() {
    super();
    this.panels = this.querySelectorAll("[data-panel]");
    this.triggers = this.querySelectorAll("[data-trigger]");
    this.triggers.forEach((trigger) => {
      trigger.addEventListener("click", ({ currentTarget }) => this.updatePanel(currentTarget));
    });
  }

  updatePanel(target) {
    this.panels.forEach((panel) => panel.classList.toggle("is-active", panel.dataset.id === target.dataset.target));
  }
}

if (!customElements.get("carousel-tabbed")) {
  customElements.define("carousel-tabbed", CarouselTabbed);
}
